import React from 'react';
import { useTranslation } from 'react-i18next';
import { TouchableOpacity } from 'react-native';

import { Box, Text } from '@components/Restyle';
import Icon from '@components/shared/Icon/Icon';
import { SUBSCRIPTION_FEATURE_KEYS } from '@src/constants/subscriptionFeatures';

interface SubscriptionRightPanelProps {
  onClose: () => void;
}

export const SubscriptionRightPanel: React.FC<SubscriptionRightPanelProps> = ({
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Box flex={1} backgroundColor='greenSecondaryMild' flexDirection='column'>
      <Box position='absolute' top={15} right={15} zIndex={1}>
        <TouchableOpacity onPress={onClose}>
          <Icon height={24} width={24} name='X' color='black' />
        </TouchableOpacity>
      </Box>
      <Box alignItems='center'>
        <Icon
          height={200}
          width={200}
          marginTop='xxl'
          paddingTop='xl'
          name='Subscription'
          color='black'
        />
      </Box>
      <Box marginStart='l' marginTop='l'>
        <Text variant='labelLarge'>
          {t('models:teams.subscriptions.everythingInTeamPlan')}
        </Text>
        <Box marginTop='m'>
          {SUBSCRIPTION_FEATURE_KEYS.map((featureKey) => (
            <Box
              key={featureKey}
              flexDirection='row'
              alignItems='center'
              marginBottom='m'>
              <Icon
                name='Check'
                height={16}
                width={16}
                color='greenSecondary'
                marginEnd='xs'
              />
              <Text variant='webBodyHintSubline' color='textPrimary'>
                {t(featureKey)}
              </Text>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};
